
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventSlug]",
      function () {
        return require("private-next-pages/events/[eventSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventSlug]"])
      });
    }
  